import React from "react";
import { Button, Paper, Stack, TextField, Typography } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

/**
 * Reusable compact search/filter bar for list pages.
 * fields: [{ key, label, value, onChange, width? }]
 */
const SearchFilterBar = ({
  fields = [],
  onSearch,
  onClear,
  helperText = "",
  searchLabel = "Search",
  clearLabel = "Clear",
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 2,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={1.5}
        alignItems={{ xs: "stretch", md: "center" }}
        flexWrap="wrap"
        useFlexGap
      >
        {fields.map((field) => (
          <TextField
            key={field.key}
            label={field.label}
            value={field.value}
            onChange={field.onChange}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                onSearch?.();
              }
            }}
            size="small"
            sx={{
              width: {
                xs: "100%",
                md: field.width || 260,
              },
              maxWidth: "100%",
            }}
          />
        ))}

        <Stack direction="row" spacing={1} alignItems="center">
          <Button
            variant="contained"
            startIcon={<SearchOutlinedIcon />}
            onClick={onSearch}
            sx={{ whiteSpace: "nowrap", px: 2.5 }}
          >
            {searchLabel}
          </Button>
          <Button variant="text" onClick={onClear}>
            {clearLabel}
          </Button>
        </Stack>
      </Stack>

      {helperText ? (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 1.25, display: "block" }}
        >
          {helperText}
        </Typography>
      ) : null}
    </Paper>
  );
};

export default SearchFilterBar;
